import React from 'react'

import { Maze } from './components/Maze'
import './App.css'

function App() {
  return (
    <div className="App">
      <Maze />
    </div>
  )
}

export default App
